import script from "./InformationDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationDetail.vue?vue&type=script&setup=true&lang=js"

export default script